import { gql } from "@/__generated__";
import { GetDeviceConfigurableMetricsQuery } from "@/__generated__/graphql";

export const GET_DEVICE_CONFIGURABLE_METRICS = gql(`#graphql
  query GetDeviceConfigurableMetrics($input: DeviceInput!) {
    device(input: $input) {
      profile {
        name
        id
      }
      alerts {
        alertConfigurations {
          id
          deviceId
          unit
          metricName
          configurations {
            __typename
            ... on RangeStateConfiguration {
              state
              comparisonCriteria
              minValue
              maxValue
              notificationDelaySec
            }
            ... on ThresholdStateConfiguration {
              state
              comparisonCriteria
              thresholdValue
              notificationDelaySec
            }
          }
        }
      }
      users {
        user {
          id
          fullName
          email
        }
        alertNotificationConfiguration {
          id
          notifyEmail
          notifyPush
          notifySms
          notifyWhatsapp
        }
      }
    }
}
`);

export type Device = GetDeviceConfigurableMetricsQuery['device'];